<template>
  <resource-create-wrapper
    :title="item ? $t('resources.calendars.duplicate_calendar') : $t('resources.calendars.new_calendar')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['calendarForm'].submit()"
    ref="resourceCreateWrapper">
    <CalendarForm
      :calendar="item"
      @isDirtyForm="isDirtyForm"
      ref="calendarForm"
      @finishedSaving="finishedSaving"></CalendarForm>
    <template #actions>
      <v-btn @click="cancel" outlined color="primary" class="spacing-right--16">
        {{ $t("generic.buttons.cancel") }}
      </v-btn>
      <v-btn @click="save" color="primary" :loading="saveLoading">
        {{ $t("generic.buttons.save") }}
      </v-btn>
    </template>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import CalendarForm from "@/components/forms/CalendarForm.vue";

  export default {
    components: {
      CalendarForm,
      ResourceCreateWrapper,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      id: {
        type: String,
        required: false,
        default: "",
      },
      title: {
        type: String,
        required: true,
      },
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        saveLoading: false,
      };
    },
    methods: {
      save() {
        this.showModal = false;
        this.saveLoading = true;
        this.$refs["calendarForm"].submit(this.$t("resources.calendars.calendar_created"));
      },
      cancel() {
        this.$refs.resourceCreateWrapper.cancelButtonHandler();
      },
      finishedSaving() {
        this.saveLoading = false;
      },
    },
  };
</script>
